import { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import anime from 'animejs';
import {
  BlockWrapper,
  BlockContentWrapper,
  CUSTOM_BREAK_POINT,
  MOBILE_BREAK_POINT,
} from 'components/Blocks/Block.styled';
import { GNB_HEIGHT } from 'components/GNB';
import {
  bounce,
  changeBg,
  jump,
  moveIt,
  moveItBack,
  setAnimationDelayLoop,
  wiggleWiggle,
} from 'utils/customAnimation';
import Images from 'components/Blocks/Landing/Images';
import { useAppSelector } from 'store/config';

type Props = {
  id: string;
};

const DELAY = 150;

const Landing = (props: Props) => {
  const isMobile = useAppSelector((state) => state.global.isMobile);

  useEffect(() => {
    anime({
      targets: '.rotateFlower',
      easing: 'linear',
      rotate: '+1turn',
      duration: 2000,
      loop: true,
    });
  }, []);

  return (
    <LandingWrapper id={props.id}>
      <BlockContentWrapper>
        <Container>
          <SVG isMobile={isMobile}>
            <Images.Line width={4} height={230} fill='#4d5ced' x={67} y={182} />
            <Images.Line
              width={4}
              height={230}
              fill='#4d5ced'
              x='96%'
              y={112}
            />
            <G>
              <Letter
                x='50%'
                y='20%'
                dx='-283'
                dy='-40'
                dominantBaseline='central'
                delay={1 * DELAY}
                className='float_1'
              >
                U
              </Letter>
              <Letter
                x='50%'
                y='20%'
                dx='-360'
                dominantBaseline='central'
                rotate={343}
                delay={0.1 * DELAY}
                className='float_1'
              >
                G
              </Letter>
              <Letter
                x='50%'
                y='20%'
                dx='-160'
                dy='-65'
                dominantBaseline='central'
                delay={2 * DELAY}
                className='float_1'
              >
                M
              </Letter>
              <Letter
                x='50%'
                y='20%'
                dx='-40'
                dy='-30'
                dominantBaseline='central'
                delay={3 * DELAY}
                className='float_1'
              >
                M
              </Letter>
              <Letter
                x='50%'
                y='20%'
                dx='55'
                dy='-65'
                dominantBaseline='central'
                rotate={358}
                delay={4 * DELAY}
                className='float_1'
              >
                Y
              </Letter>

              <Letter
                x='50%'
                y='20%'
                dx='122'
                dy='-40'
                dominantBaseline='central'
                rotate={7}
                delay={5 * DELAY}
                className='float_2'
              >
                L
              </Letter>
              <Letter
                x='50%'
                y='20%'
                dx='285'
                dy='-55'
                dominantBaseline='central'
                rotate={354}
                delay={7 * DELAY}
                className='float_2'
              >
                N
              </Letter>
              <Letter
                x='50%'
                y='20%'
                dx='200'
                dy='-25'
                dominantBaseline='central'
                rotate={4}
                delay={6 * DELAY}
                className='float_2'
              >
                A
              </Letter>
              <Letter
                x='50%'
                y='20%'
                dx='375'
                dy='-20'
                dominantBaseline='central'
                rotate={7}
                delay={8 * DELAY}
                className='float_2'
              >
                D
              </Letter>
            </G>
            {/* )} */}
          </SVG>

          <Images.Background
            src='/images/background/landing.png'
            alt='background'
          />
          {/* <BgLine.Yellow />
          <BgLine.Pink />
          <BgLine.Blue /> */}

          <GummyWrapper>
            <Images.BgFlower
              top={622}
              left={-20}
              src='/images/bg_flower.png'
              alt='bg_flower'
            />
            <Images.BgFlower
              top={457}
              left={50}
              src='/images/bg_flower.png'
              alt='bg_flower'
            />
            <Images.BgFlower
              top={571}
              left={150}
              src='/images/bg_flower.png'
              alt='bg_flower'
            />
            <Images.BgFlower
              top={617}
              left={833}
              src='/images/bg_flower.png'
              alt='bg_flower'
            />
            <Images.BgFlower
              top={524}
              left={949}
              src='/images/bg_flower.png'
              alt='bg_flower'
            />
            <Images.BgFlower
              top={646}
              left={1004}
              src='/images/bg_flower.png'
              alt='bg_flower'
            />

            <GummyInnerWrapper>
              <Images.WelGgome src='/images/welggome.png' alt='welggome' />
              {/* Gummy Start */}
              <Images.GummyBox src='/images/gummy_box.png' alt='gummy_box' />
              <Images.GummyNoise
                src='/images/gummy_noise.gif'
                alt='gummy_noise'
              />
              <Images.GummyBorder
                src='/images/gummy_border.png'
                alt='gummy_border'
              />
              <Images.Gummy src='/images/gummy.png' alt='gummy' />
              {/* <SVG style={{ position: 'absolute', top: 135, left: -23 }}>
                <text fontSize={80} fill='var(--bg-color)' x='50%' y='50%'>
                  ?
                </text>
              </SVG> */}
              <Images.GummyLeftFlower
                src='/images/bg_flower_3.png'
                alt='bg_flower_3'
                className='rotateFlower'
              />
              <Images.GummyLeftFlower2
                src='/images/bg_flower_3.png'
                alt='bg_flower_3'
              />
              <Images.GummyRightFlower
                src='/images/bg_flower_2.png'
                alt='bg_flower_2'
              />
              <Images.GommingSoon
                src='/images/ggoming_soon.png'
                alt='ggoming_soon'
              />
              <Images.Progress src='/images/progress.gif' alt='progress' />
              <Images.Heart src='/images/heart.png' alt='heart' />
              {/* Gummy End */}
            </GummyInnerWrapper>
            <Images.Cloud src='/images/cloud.png' alt='cloud' />
            <Images.Rainbow src='/images/rainbow.png' alt='rainbow' />
          </GummyWrapper>

          {/* Background Start */}

          <Images.BgStar
            top={207}
            left={54}
            src='/images/star.png'
            alt='star'
          />
          <Images.BgStar
            top={247}
            left={54}
            src='/images/star.png'
            alt='star'
          />

          <Images.BgStar
            top={497}
            right='3%'
            src='/images/star.png'
            alt='star'
          />
          <Images.BgStar
            top={537}
            right='3%'
            src='/images/star.png'
            alt='star'
          />

          {/* Background End */}
        </Container>
      </BlockContentWrapper>
    </LandingWrapper>
  );
};

const LandingWrapper = styled(BlockWrapper)`
  padding-top: ${GNB_HEIGHT}px;
`;

const Container = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  width: 100%;
  height: calc(100vh - ${GNB_HEIGHT}px);
  background-color: #ffffff;
  background-image: linear-gradient(
      to right,
      rgba(247, 174, 220, 0.2) 2px,
      transparent 1px
    ),
    linear-gradient(to bottom, rgb(247, 174, 220, 0.2) 2px, transparent 1px);
  background-size: calc(10 * 6px) calc(10 * 6px);
`;

const GummyWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;

  max-width: ${CUSTOM_BREAK_POINT}px;
`;

const GummyInnerWrapper = styled.div`
  position: absolute;
  width: 369px;
  height: 466px;

  @media (max-width: ${MOBILE_BREAK_POINT}px) {
    scale: 0.7;
    translate: 0 -15%;
  }
`;

const SVG = styled.svg<{ isMobile?: boolean }>`
  width: 100%;
  height: 100%;

  filter: ${(props) =>
    props.isMobile ? 'drop-shadow(3px 4px var(--bg-color))' : 'none'};
`;

const Letter = styled.text<{ delay: number }>`
  fill: white;
  stroke: var(--bg-color);
  stroke-width: 3px;
  text-anchor: middle;
  font-size: 165px;
  font-family: 'Titan One', Arial, Helvetica, sans-serif;
  visibility: hidden;
  transform-origin: center center;

  animation: ${moveIt} 0.9s ease-in-out ${(props) => props.delay}ms normal
      forwards,
    ${bounce} 1s ease-in-out 1.1s alternate infinite;
  filter: drop-shadow(6px 8px var(--bg-color));

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    scale: 0.8;
    translate: 0 -10%;
  }

  @media (max-width: 720px) {
    scale: 0.6;
    translate: 0 -20%;
  }

  @media (max-width: ${MOBILE_BREAK_POINT}px) {
    visibility: visible;
    scale: 0.43;
    translate: 0 -25%;
  }
`;

const G = styled.g`
  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
  }

  @media (max-width: 720px) {
  }

  @media (max-width: ${MOBILE_BREAK_POINT}px) {
    @keyframes mobileBounce {
      0% {
        transform: scale(0.4) translateX(70%) translateY(60px);
      }

      100% {
        transform: scale(0.4) translateX(70%) translateY(50px);
      }
    }

    animation: mobileBounce 1s ease-in-out 1.1s alternate infinite;
    transform: scale(0.4) translateX(70%) translateY(60px);
  }
`;

const BgLineCommon = styled.div`
  position: absolute;
  width: calc(100vw + 3px);
  height: 50px;
  bottom: 150px;
  left: -3px;
  visibility: visible;

  @media (max-width: ${MOBILE_BREAK_POINT}px) {
    visibility: hidden;
  }
`;

const BgLine = {
  Yellow: styled(BgLineCommon)`
    background-color: rgb(248, 227, 56);
    rotate: -3deg;

    animation: ${changeBg.yellow} 1.5s steps(1) infinite;
  `,
  Pink: styled(BgLineCommon)`
    background-color: rgb(247, 174, 220);
    rotate: 0deg;

    animation: ${changeBg.pink} 1.5s steps(1) infinite;
  `,
  Blue: styled(BgLineCommon)`
    background-color: var(--bg-color);
    rotate: 3deg;

    animation: ${changeBg.blue} 1.5s steps(1) infinite;
  `,
};

export default Landing;
